// test1789
(1789 && 0);
